module.exports = __webpack_public_path__ + "static/RR5-58155b312f5638fa8d07baaaaa366c8c.jpg";